import { render, staticRenderFns } from "./HomeProduct.vue?vue&type=template&id=032b2f89&scoped=true&"
import script from "./HomeProduct.vue?vue&type=script&lang=js&"
export * from "./HomeProduct.vue?vue&type=script&lang=js&"
import style0 from "./HomeProduct.vue?vue&type=style&index=0&id=032b2f89&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032b2f89",
  null
  
)

export default component.exports